module.exports = __webpack_public_path__ + "img/illustration-step-1-01.83f1f826.svg";